import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import IconButton from '@material-ui/core/IconButton'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import connect from 'react-redux/es/connect/connect'
import styles from './style'

import {
  loginWithSkyward
} from 'redux/actions'

import DialogTitle from 'common/components/dialog/DialogTitle'
import DialogContent from 'common/components/dialog/DialogContent'
import {
  E_KEY_ENTER
} from "redux/constants";

import {Divider} from "@material-ui/core";

class LoginDialogClass extends React.Component {
  constructor(props) {
    super(props);
    // create a ref to store the textInput DOM element
    this.state = {
      fieldsEnabled:true,
      password:'',
      email:'',
      showPassword: false
    }
    this.enableFields = this.enableFields.bind(this)
    this.submitLogin = this.submitLogin.bind(this)
    this.forgotPassword = this.forgotPassword.bind(this)
    this.setValue = this.setValue.bind(this)
    this.checkKeystroke = this.checkKeystroke.bind(this)
    this.refEmail = React.createRef()
    this.refPassword = React.createRef()
    this.refPasswordInput = React.createRef()
  }
  
  enableFields(e) {
    const target = e.target
    this.setState({fieldsEnabled:true})
    setTimeout(()=>target.focus(), 50)
  }

  forgotPassword() {
    if(this.state.email.length === 0 || this.state.email.indexOf('@') < 1) {
      this.props.snackMessageError('Please enter a valid email address.')
    } else {
      this.props.snackMessageInfo('One moment please.')
      this.props.forgotPasswordSend({
        email: this.state.email,
        returnUrl: window.location.pathname.startsWith('/mgmt') ? '/mgmt' : '/',
      })
    }
  }

  componentDidMount() {
    //testing
    window.stHooks.addHook('loginEmail', (e)=>this.setValue(e, 'email'))
    window.stHooks.addHook('loginPwd', (e)=>this.setValue(e, 'password'))
    window.stHooks.addHook('loginSubmit', ()=>this.submitLogin())
  }
  componentWillUnmount() {
    window.stHooks.removeHook(['loginEmail', 'loginPwd','loginSubmit'])
  }

  setValue(e, label) {
    if(typeof e === 'string') {
      this.setState({[label]:e})
    } else {
      this.setState({[label]:e.target.value})
    }
  }

  submitLogin(e) {
    if(this.state.email.length > 0) {
      this.props.loginSend({
        email: this.state.email,
        password: this.state.password,
        rememberMe: this.state.rememberMe,
      })
    } else {
      this.props.snackMessageError('Please enter a valid email address.')
    }
  }

  checkKeystroke(e) {
    if(e.key === E_KEY_ENTER) {
      this.submitLogin()
    }
  }

  render() {
    const {classes, close, forgotPasswordSend, loginType, organizationName='', loginWithSkyward, loginWithSkywardParameters} = this.props
    const onClose = (close)? close : ()=>alert('Please login.')

    const includeSkywardLogin = loginType !== 'install' && window.SKYWARD_CONFIGURED === 'true'

    let titleText = 'Please login'
    let skywardRedirectClientUrl = ''
    switch(loginType) {
      case 'admin' :
        titleText = 'Administrator login'
        skywardRedirectClientUrl = '/mgmt'
        break
      case 'kiosk' :
        titleText = 'Kiosk login'
        skywardRedirectClientUrl = ''
        break
      case 'install' :
        titleText = 'Installer login'
        skywardRedirectClientUrl = '/instellerizer'
        break
      default :
        alert(loginType)
    }
    //titleText = (organizationName.length > 0)? organizationName + ' - ' + titleText : titleText
    return (
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open
      >
        {organizationName?<DialogTitle id="customized-dialog-title" style={{textAlign:'center'}}>
         {organizationName}
        </DialogTitle>:null}
        <DialogContent className={classes.dialogContentRoot} style={{marginTop: '10px'}}>
          <Grid container>
            <Grid item xs={12} style={{
              textAlign:'center',
              padding:0,
              background:'url(/images/school_trak_icon_dark.svg)',
              backgroundRepeat:'no-repeat',
              backgroundSize:'120px 120px',
              minHeight: '120px'
            }}>
              {/*<img
                src=''
                alt='SchoolTRAK logo'
                style={{
                  backgroundRepeat:'no-repeat',
                  height: '120px',
                  width: '120px',
                  display: 'inline-block',
                  marginLeft:0,
                  marginRight:0,
                  position:'relative',
                  left:12
                }}
              />
            */}
              <span style={{
                fontWeight:'normal',
                fontSize:53,
                display:'inline-block',
                fontFamily:'Roboto, Helvetica',
                position:'relative',
                left:'20px',
                top:'31px'
              }}>School<span style={{fontWeight:'bold'}}>TRAK</span>
                <span style={{fontSize:20, position:'absolute', right:-20}}>&trade;</span></span>
            </Grid>
            <Grid item xs={12} style={{
              textAlign:'center',
              padding:20
            }}>
              <h2 style={{margin:5, fontWeight:'normal'}}>{titleText}</h2>              
            </Grid>

          </Grid>
          <Grid container >
            <div style={{width: '80%', display: 'flex', flexDirection: 'column', justifyContent: 'center', margin: 'auto'}}>
              <Grid item xs={12}>
                <TextField
                  disabled={!this.state.fieldsEnabled}
                  id="login-email"
                  label="Email"
                  fullWidth
                  className={classes.textField}
                  margin="normal"
                  variant="outlined"
                  onClick={this.enableFields} //potential fix for not allowing login on anything but chrome - move this to parent Grid item
                  ref={this.refEmail}
                  value={this.state.email}
                  type="email"
                  autoComplete="email"
                  onChange={(e)=>this.setValue(e, 'email')}
                  onKeyDown={this.checkKeystroke}
                />
              </Grid>
              <Grid item xs={12}>
                <div style={{ position: 'relative', marginTop: 16 }}>
                <TextField
                  disabled={!this.state.fieldsEnabled}
                  id="login-pwd"
                  label="Password"
                  fullWidth
                  type={this.state.showPassword ? 'text' : 'password'}
                  autoComplete="password"
                  className={classes.textField}
                  margin="none"
                  variant="outlined"
                  onClick={this.enableFields}
                  ref={this.refPassword}
                  value={this.state.password}
                  onChange={(e)=>this.setValue(e, 'password')}
                  onKeyDown={this.checkKeystroke}
                  inputProps={{ style: { paddingRight: '48px' } }}
                  inputRef={this.refPasswordInput}
                />
                <IconButton
                  aria-label={this.state.showPassword ? 'Hide password' : 'Show password'}
                  onClick={() => {
                    const input = this.refPasswordInput.current;
                    let savedStart = null, savedEnd = null;
                    if (input) {
                      try {
                        savedStart = input.selectionStart;
                        savedEnd = input.selectionEnd;
                      } catch (e) {
                        // password-type inputs throw on selectionStart in some browsers
                      }
                    }
                    this.setState(prev => ({ showPassword: !prev.showPassword }), () => {
                      if (input) {
                        requestAnimationFrame(() => {
                          if (savedStart !== null) {
                            input.setSelectionRange(savedStart, savedEnd);
                          } else {
                            const len = input.value.length;
                            input.setSelectionRange(len, len);
                          }
                          input.focus();
                        });
                      }
                    });
                  }}
                  onMouseDown={(e) => e.preventDefault()}
                  disableRipple
                  style={{
                    position: 'absolute',
                    right: 8,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    padding: 6,
                    color: this.state.showPassword
                      ? 'rgba(0,0,0,0.75)'
                      : 'rgba(0,0,0,0.45)',
                    transition: 'color 0.2s ease'
                  }}
                >
                  {this.state.showPassword
                    ? <VisibilityOff fontSize="small" />
                    : <Visibility fontSize="small" />
                  }
                </IconButton>
                </div>
                <div className={classes.rememberForgotRow}>
                  <div className={classes.rememberMeContainer} style={{ visibility: loginType === 'admin' ? 'visible' : 'hidden' }}>
                    <input
                      type="checkbox"
                      id="remember-me"
                      checked={this.state.rememberMe || false}
                      onChange={(e) => this.setState({ rememberMe: e.target.checked })}
                    />
                    <label htmlFor="remember-me" className={classes.rememberMeLabel}>
                      Extend Login Time
                    </label>
                  </div>
                  {forgotPasswordSend &&
                    <Button onClick={this.forgotPassword} color="secondary">
                      forgot password
                    </Button>
                  }
                </div>
              </Grid>
            </div>
          </Grid>
          <div style={{flexGrow: 8, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '30px', paddingBottom: '60px', marginTop: '30px'}}>
            <Button id='login-submit' onClick={this.submitLogin} variant="contained" color="primary" style={{width: '80%', height: '54px'}}>
              Login
            </Button>
            {includeSkywardLogin ? <Divider style={{width: '80%'}}/> : null}
            {includeSkywardLogin ?             
            <Button id='login-submit' onClick={() => loginWithSkyward({redirectUrl: skywardRedirectClientUrl, parameters: loginWithSkywardParameters})} style={{width: '80%', height: '54px'}}
              color="primary" variant='outlined'>
                Continue with Skyward           
            </Button> : null}           
          </div>    
        </DialogContent>
      </Dialog>
    )
  }
}

const mapStateToProps = state => {return {}}

const mapDispatchToProps = {
  loginWithSkyward
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(LoginDialogClass))